module.exports = __webpack_public_path__ + "static/media/team5.691ad097.jpg";